import { useState } from "react";
import { api } from "../api";

export default function Login({ onSuccess }: { onSuccess: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(false);
    try {
      await api.login(username, password);
      onSuccess();
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gh-bg">
      <form
        onSubmit={submit}
        className="w-80 rounded-lg border border-gh-border bg-gh-surface p-6 space-y-4"
      >
        <h1 className="text-lg font-semibold text-center">Flags CMS</h1>
        <div className="space-y-1">
          <label className="text-sm text-gh-muted" htmlFor="login-username">
            Username
          </label>
          <input
            id="login-username"
            data-testid="login-username"
            className="w-full rounded border border-gh-border bg-gh-bg px-3 py-2 text-sm"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm text-gh-muted" htmlFor="login-password">
            Password
          </label>
          <input
            id="login-password"
            data-testid="login-password"
            type="password"
            className="w-full rounded border border-gh-border bg-gh-bg px-3 py-2 text-sm"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {error && (
          <p data-testid="login-error" className="text-sm text-red-400">
            Невірний логін або пароль
          </p>
        )}
        <button
          type="submit"
          data-testid="login-submit"
          disabled={busy}
          className="w-full rounded bg-blue-600 px-3 py-2 text-sm font-medium text-white disabled:opacity-50"
        >
          {busy ? "..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
